import { Component } from "react";
import i18n from "../../i18n";

/**
 * Base class for components that need to respond to language changes
 * Provides common boilerplate for i18n language change handling
 * Uses React.Component for more frequent re-renders to ensure language changes are always reflected
 */
class LanguageAwareComponent extends Component {
    constructor(props) {
        super(props);
        this.state = {
            ...this.state,
            currentLanguage: i18n.language || 'en'
        };
    }

    componentDidMount() {
        // Listen for language changes and update locale
        i18n.on('languageChanged', this.handleLanguageChange);
        
        // Call parent component's componentDidMount if it exists
        if (super.componentDidMount) {
            super.componentDidMount();
        }
    }

    componentWillUnmount() {
        // Clean up language change listener
        try {
            i18n.off('languageChanged', this.handleLanguageChange);
        } catch (error) {
            console.warn('Failed to remove i18n listener:', error);
        }
        
        // Call parent component's componentWillUnmount if it exists
        if (super.componentWillUnmount) {
            super.componentWillUnmount();
        }
    }

    handleLanguageChange = (lng) => {
        // Update current language state to trigger re-render
        const newLanguage = lng || i18n.language || 'en';
        
        this.setState({ 
            currentLanguage: newLanguage
        }, () => {
            // Call child component's onLanguageChanged callback if it exists
            if (this.onLanguageChanged) {
                this.onLanguageChanged(newLanguage);
            }
        });
    };

    /**
     * Override this method in child components to handle language changes
     * @param {string} newLanguage - The new language code
     */
    onLanguageChanged(newLanguage) {
        // Default implementation - child components can override this
    }
}

export default LanguageAwareComponent; 